const pad = (n: number) => String(n).padStart(2, '0')

/** A Date as a `<input type="datetime-local">` value (local time, minute precision). */
export function toDatetimeLocalValue(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

/**
 * A datetime-local value ("2026-10-20T14:30", interpreted in the browser's timezone) as ISO 8601
 * with the local offset, e.g. "2026-10-20T14:30:00-05:00". Null when the value is not a date.
 */
export function datetimeLocalToIso(value: string): string | null {
  if (!value) return null
  const d = new Date(value)
  if (isNaN(d.getTime())) return null
  const offsetMin = -d.getTimezoneOffset()
  const sign = offsetMin >= 0 ? '+' : '-'
  const abs = Math.abs(offsetMin)
  return `${toDatetimeLocalValue(d)}:${pad(d.getSeconds())}${sign}${pad(Math.floor(abs / 60))}:${pad(abs % 60)}`
}
